import { gql } from "@apollo/client"
import { DEPENDENT_FIELDS } from "./DependentFields"

export const DEPENDENTS_ON_ENGAGEMENT_FRAGMENT = gql`
  ${DEPENDENT_FIELDS}
  fragment DependentsOnEngagementFragment on Engagement {
    dependents {
      collection {
        ...DependentFields
      }
    }
  }
`
